// extracted by mini-css-extract-plugin
export var actionButton = "_6b-0";
export var attachmentLine = "_6b-1";
export var fileInput = "_6b-2";
export var fileUploadWrapper = "_6b-4";
export var footer = "_6b-3";
export var modalContent = "_6b-5";
export var paperclip = "_6b-6";
export var quillEditor = "_6b-7";